import React from "react";

export const TwitterIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27.872"
      height="27.873"
      viewBox="0 0 27.872 27.873"
    >
      <path
        data-name="Icon awesome-twitter-square"
        d="M24.886,2.25H2.986A2.987,2.987,0,0,0,0,5.236v21.9a2.987,2.987,0,0,0,2.986,2.986h21.9a2.987,2.987,0,0,0,2.986-2.986V5.236A2.987,2.987,0,0,0,24.886,2.25Zm-3.042,9.88c.012.174.012.355.012.529a11.53,11.53,0,0,1-11.609,11.61A11.556,11.556,0,0,1,3.982,22.44a8.6,8.6,0,0,0,.983.05,8.181,8.181,0,0,0,5.064-1.742,4.086,4.086,0,0,1-3.814-2.831,4.4,4.4,0,0,0,1.842-.075,4.081,4.081,0,0,1-3.266-4.007v-.05a4.078,4.078,0,0,0,1.842.516,4.072,4.072,0,0,1-1.817-3.4,4.03,4.03,0,0,1,.554-2.059,11.586,11.586,0,0,0,8.412,4.268,4.089,4.089,0,0,1,6.962-3.727A8,8,0,0,0,23.331,8.4a4.07,4.07,0,0,1-1.792,2.246,8.12,8.12,0,0,0,2.352-.635A8.589,8.589,0,0,1,21.844,12.13Z"
        transform="translate(0 -2.25)"
      />
    </svg>
  );
};
